import { ActivityOptions } from "~/packages/taskrouter";
import { ErrorCode, ErrorSeverity, FlexSdkError } from "~/modules/error";
import { sendTrackingEvent } from "../../ActionUtils";
import { EVENTS } from "~/modules/analytics/Analytics";
import { Action } from "~/modules/actions/Action";
import { ContextManager, ContextInstance } from "~/modules/contextManager/ContextManager";
import { TaskRouterImpl } from "~/packages/taskrouter/TaskRouterImpl";
import { getLogger, LoggerName } from "~/modules/logger";
import { AnalyticsImpl } from "~/modules/analytics/AnalyticsImpl";



export interface SetWorkerActivityOptions {
    activityUpdateOptions?: ActivityOptions;
}





















export class SetWorkerActivity implements Action<Promise<void>> {
    


    #targetWorkerSid: string;

    


    #activitySid: string;

    


    #options?: SetWorkerActivityOptions;

    constructor(targetWorkerSid: string, activitySid: string, options?: SetWorkerActivityOptions) {
        this.#targetWorkerSid = targetWorkerSid;
        this.#activitySid = activitySid;
        this.#options = options;
    }

    async run(ctx: {}) {
        const context = ctx as ContextManager;
        const taskRouter = context.retrieveInstanceOf(ContextInstance.TaskRouter, TaskRouterImpl);
        await taskRouter.init();
        const logger = getLogger(context)(LoggerName.Client);
        const analytics = context.retrieveInstanceOf(ContextInstance.AnalyticsImpl, AnalyticsImpl);

        const activityUpdateOptions = this.#options?.activityUpdateOptions;
        const worker = taskRouter.worker;

        logger.debug(
            `setWorkerActivity invoked with activitySid: ${this.#activitySid} and targetWorkerSid: ${
                this.#targetWorkerSid
            }`
        );

        if (!worker) {
            const errorMsg = "setWorkerActivity: worker is not initialized";
            logger.error(errorMsg);
            throw new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg);
        }

        if (this.#activitySid === worker.activity?.sid) {
            const warnMsg = `setWorkerActivity: Activity with sid ${this.#activitySid} is already set`;

            sendTrackingEvent(EVENTS.SetWorkerActivityCompleted, analytics, worker, {
                warning: warnMsg,
                targetWorkerSid: this.#targetWorkerSid,
                activitySid: this.#activitySid
            });

            logger.warn(warnMsg);
            return Promise.resolve();
        }

        try {
            await worker.setWorkerActivity(this.#targetWorkerSid, this.#activitySid, activityUpdateOptions);

            sendTrackingEvent(EVENTS.SetWorkerActivityCompleted, analytics, worker, {
                targetWorkerSid: this.#targetWorkerSid,
                activitySid: this.#activitySid
            });

            return Promise.resolve();
        } catch (error) {
            const response = error?.message;

            let errorMsg: string;

            if (
                !!response &&
                response.match(/Worker WK.* cannot have its activity updated while it has .* pending reservations/)
            ) {
                errorMsg = `setWorkerActivity: Failed to set current activity to activity ${this.#activitySid} due to \
pending reservations`;
            } else {
                errorMsg = `setWorkerActivity: Failed to set current activity to activity ${this.#activitySid}`;
            }

            logger.error(errorMsg);
            sendTrackingEvent(EVENTS.SetWorkerActivityCompleted, analytics, worker, {
                error: errorMsg,
                targetWorkerSid: this.#targetWorkerSid,
                activitySid: this.#activitySid
            });
            throw new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg);
        }
    }
}
